import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: (failureCount, error: Error & { status?: number }) => {
        // Network/transport errors won't have a status and should be retried
        if (!error?.status) {
          return failureCount < 3;
        }

        // Don't retry on client errors except 401
        if (error.status >= 400 && error.status < 500 && error.status !== 401) {
          return false;
        }

        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
